<template>
  <div class="drug-venue" v-track-page="'yd_category'">
    <SearchBar
      class="top-box"
      :placeholderText="placeholderText || '商品名称/拼音首拼/症状/疾病/厂家'"
      show-action
      :focus="false"
      :showBack="false"
      @emitClick="routerPage('/search-main')"
    >
      <!-- <div slot="action" @click="routerPage('/request-cart')">
        <IconFont id="buycar" icon-name="gouwuche" style="font-size: 24px" />
      </div> -->
      <CartIcon slot="action" @onClick="routerPage('/request-cart')" :cartCountTrolley="cartCountTrolley" />
    </SearchBar>
    <div class="container" :class="{ showSiderbar }">
      <siderbar
        class="siderbar"
        v-show="showSiderbar"
        :category="category"
        :activeId="activeId"
        @changeCategory="changeCategory"
      />
      <div class="content">
        <section v-if="(orderList || []).length">
          <van-list v-model="loading" :finished="finished" :finished-text="`没有更多${typeText}了`" @load="onLoad">
            <div v-for="(item, key) in orderList" :key="key.itemId">
              <ProductItem
                :showBorder="showSiderbar"
                :item="item"
                :fly-button="true"
                @changeGoodsAmount="changeGoodsAmount"
              />
            </div>
          </van-list>
        </section>
        <van-empty
          class="empty-margin"
          v-else-if="finished"
          description="暂无商品"
          image="//static.91jkys.com/attachment/20211021101256064_c7a906b021bc4f839e3e9fd8c02c9236.png"
        ></van-empty>
      </div>
    </div>
  </div>
</template>
<script>
import SearchBar from '@/components/search/SearchBar';
import Siderbar from './components/Siderbar';
import ProductItem from '@/components/ProductItem';
import { CartIcon } from '@/components/search/index.js';

export default {
  components: { SearchBar, Siderbar, ProductItem, CartIcon },
  data() {
    return {
      showSiderbar: true, // 是否显示siderbar
      orderList: [], // 商品列表
      category: [], // 商品类目列表
      loading: false,
      finished: false,
      pageNo: 1,
      pageSize: 20,
      currentCatId: null, // 当前选取类目的id
      keyWord: '', // 当前用户所输入关键字
      canClick: true,
      type: 'drug', // drug 药品 goods 商品
      searchValue: '',
      placeholderText: '',
      cartCountTrolley: null,
      activeId: { active: this.$store.state.order.siderbarActive || 0 }
    };
  },
  computed: {
    typeText: function () {
      return this.type === 'goods' ? '商品' : '药品';
    }
  },
  beforeRouteEnter(to, from, next) {
    // if (to.query?.from === 'goods') {
    //   document.title = `商品会场`;
    //   next();
    // } else {
    document.title = `全部分类`;
    next();
    // }
  },
  async created() {
    this.type = this.$route.query?.from || 'drug';

    await this.fetchCategory();
    await this.onLoad();
  },
  mounted() {
    this.getCartCountTrolley();
  },
  methods: {
    async changeGoodsAmount() {
      await this.getCartCountTrolley();
    },
    getCartCountTrolley() {
      this.$fetch.getCartCountTrolley().then((res) => {
        this.cartCountTrolley = res?.amount || null;
      });
    },
    // 跳转
    routerPage(path) {
      this.$router.push(path);
    },
    onCancel(e) {
      console.log(e);
    },
    onSearch(e) {
      console.log(e);
    },
    onClear() {},
    onFocus() {},

    searchCancel() {
      // this.currentCatId = this.category[0].id;
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
    },
    searchFocus(val) {
      this.pageNo = 1;
      this.finished = false;
      this.keyWord = val;
      this.onLoad();
    },

    changeCategory(index) {
      // 这里是用户事件触发 其实是没有报错风险的
      if (this.category.length) this.currentCatId = this.category[index].id;
      this.pageNo = 1;
      this.finished = false;
      this.onLoad();
      this.$store.commit('order/setSiderbarActive', this.activeId.active);
    },
    async fetchCategory() {
      let cat = this.type === 'goods' ? await this.$fetch.fetchGoodsCategory() : await this.$fetch.fetchCategory();
      this.category = cat;
      if (this.category.length) this.currentCatId = this.category[this.$store.state.order.siderbarActive || 0].id;
    },
    async fetchData() {
      if (this.pageNo === 1) {
        this.orderList = [];
      }
      const params = {
        pageSize: this.pageSize,
        pageNo: this.pageNo
      };
      if (this.type === 'goods') params.isDrug = 0;

      if (this.showSiderbar) {
        params.drugCategoryId = this.currentCatId;
      } else {
        params.keyWord = this.keyWord;
      }

      if (!this.showSiderbar && this.keyWord) {
        // eslint-disable-next-line
        Telescope.trackEvent({ trackId: 'yd_category_search_request', custom: { keyWord: this.keyWord } });
      }

      try {
        const { list = [], hasMore } = await this.$fetch.fetchProductList(params);
        // 兼容性问题
        if (this.pageNo === 1) {
          list.forEach((e) => {
            e.currentValue = e.currentValue || 0;
            e.goodsNumAdded = e.goodsNumAdded || 0;
          });
          console.log(list);
          this.orderList = list;
        } else {
          this.orderList.push(...list);
        }

        if (!hasMore) {
          this.finished = true;
        }
      } catch (err) {
        this.canClick = true;
      }
    },
    async onLoad() {
      await this.fetchData();
      this.loading = false;
      this.pageNo += 1;
    },
    pageToRequestCart() {
      // eslint-disable-next-line
      Telescope.trackEvent({ trackId: 'yd_category_productlist_requirement' });
      this.$router.push({ name: 'requestCart' });
    }
  }
};
</script>
<style lang="scss" scoped>
.drug-venue {
  position: relative;
  width: 100%;
  // overflow-x: hidden;
  // .nav-search {
  //   position: fixed;
  //   top: 0;
  //   left: 0;
  //   width: 100%;
  //   height: 49px;
  //   background: #fff;
  //   z-index: 4;
  //   ::v-deep .van-search__content--round {
  //     border-radius: 22px;
  //   }
  //   ::v-deep .van-search {
  //     height: 49px !important;
  //     .van-field__left-icon {
  //       position: relative;
  //       top: -3px;
  //     }
  //   }
  // }
  .top-box {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 49px;
    background: #fff;
    z-index: 4

  }
  .siderbar {
    width: 88px;
    min-width: 88px;
    overflow-x: hidden;
    position: fixed;
    z-index: 3;
    top: 49px;
    left: 0;
    height: calc(100vh - 49px);

    background: #f7f8fa;
    overflow-y: auto;
  }
  .container {
    &.showSiderbar {
      padding-left: 79px;
    }
    // padding-top: 49px;
    width: 100%;
  }

  .content {
    height: 100vh;
    width: 100%;
    padding-top: 53px;
    background: #fff;
    .empty-margin {
      margin-top: 64px;
    }
    ::v-deep .van-list {
      background: #fff !important;
    }
  }

  .reques-cart {
    .request-count {
      display: inline-block;
      position: absolute;
      top: 2px;
      right: -2px;
      width: 12px;
      height: 12px;
      background: #fa4b4b;
      border-radius: 12px;
    }
    position: fixed;
    right: 12px;
    bottom: 20px;
    z-index: 5;
    width: 48px;
    height: 48px;
    border-radius: 48px;
    background: #ffffff;
    box-shadow: 0px 4px 12px 0px rgba(38, 38, 38, 0.2);
    .img {
      width: 25px;
      height: 25px;
    }
  }
  ::v-deep .van-list__finished-text {
    font-size: 14px;
    color: #8c8c8c;
    height: 72px;
    line-height: 72px;
  }
}

@keyframes mymove {
  0% {
    transform: scale(1);
  }
  25% {
    transform: scale(0.8);
  }
  50% {
    transform: scale(0.6);
  }
  75% {
    transform: scale(0.4);
  }
  100% {
    transform: scale(0.2);
  }
}
.moveToCart {
  animation: mymove 0.5s ease-in-out;
}
</style>
